'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var Signer = require('./Signer.cjs');
var TransactionBuilder = require('./TransactionBuilder.cjs');
var arrays = require('./utils/arrays.cjs');
class TransactionBuilderGroup {
  constructor() {
    let builders = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.builders = builders;
    this.options = options;
  }
  prepend(builder) {
    const newBuilders = Array.isArray(builder) ? builder : [builder];
    return new TransactionBuilderGroup([...newBuilders, ...this.builders], this.options);
  }
  append(builder) {
    const newBuilders = Array.isArray(builder) ? builder : [builder];
    return new TransactionBuilderGroup([...this.builders, ...newBuilders], this.options);
  }
  add(builder) {
    return this.append(builder);
  }
  sequential() {
    return new TransactionBuilderGroup(this.builders, {
      ...this.options,
      parallel: false
    });
  }
  parallel() {
    return new TransactionBuilderGroup(this.builders, {
      ...this.options,
      parallel: true
    });
  }
  isParallel() {
    var _this$options$paralle;
    return (_this$options$paralle = this.options.parallel) !== null && _this$options$paralle !== void 0 ? _this$options$paralle : false;
  }
  merge() {
    if (this.builders.length === 0) {
      return new TransactionBuilder.TransactionBuilder();
    }
    return this.builders.reduce((builder, next) => builder.add(next), this.builders[0].empty());
  }
  build(context) {
    return this.builders.map(builder => builder.build(context));
  }
  async setLatestBlockhash(context) {
    const hasBlockhashlessBuilder = this.builders.some(builder => !builder.options.blockhash);
    if (!hasBlockhashlessBuilder) return this;
    const blockhash = await context.rpc.getLatestBlockhash();
    return this.map(builder => builder.options.blockhash ? builder : builder.setBlockhash(blockhash));
  }
  async buildWithLatestBlockhash(context) {
    return (await this.setLatestBlockhash(context)).build(context);
  }
  async buildAndSign(context) {
    const transactions = await this.buildWithLatestBlockhash(context);
    const signers = this.builders.map(builder => builder.getSigners(context));
    return Signer.signAllTransactions(arrays.zipMap(transactions, signers, (transaction, txSigners) => ({
      transaction,
      signers: txSigners !== null && txSigners !== void 0 ? txSigners : []
    })));
  }
  async send(context) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this.runAll(await this.buildAndSign(context), async tx => context.rpc.sendTransaction(tx, options));
  }
  async sendAndConfirm(context) {
    var _this$builders$find, _options$confirm;
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const blockhashWithExpiryBlockHeight = (_this$builders$find = this.builders.find(builder => typeof builder.options.blockhash === 'object')) === null || _this$builders$find === void 0 ? void 0 : _this$builders$find.options.blockhash;
    let strategy;
    if ((_options$confirm = options.confirm) !== null && _options$confirm !== void 0 && _options$confirm.strategy) {
      strategy = options.confirm.strategy;
    } else {
      var _options$confirm$stra, _options$confirm2;
      const blockhash = blockhashWithExpiryBlockHeight !== null && blockhashWithExpiryBlockHeight !== void 0 ? blockhashWithExpiryBlockHeight : await context.rpc.getLatestBlockhash();
      strategy = (_options$confirm$stra = (_options$confirm2 = options.confirm) === null || _options$confirm2 === void 0 ? void 0 : _options$confirm2.strategy) !== null && _options$confirm$stra !== void 0 ? _options$confirm$stra : {
        type: 'blockhash',
        ...blockhash
      };
    }
    return this.runAll(await this.buildAndSign(context), async tx => {
      const signature = await context.rpc.sendTransaction(tx, options.send);
      const result = await context.rpc.confirmTransaction(signature, {
        ...options.confirm,
        strategy
      });
      return {
        signature,
        result
      };
    });
  }
  map(fn) {
    return new TransactionBuilderGroup(this.builders.map(fn));
  }
  filter(fn) {
    return new TransactionBuilderGroup(this.builders.filter(fn));
  }
  async runAll(array, fn) {
    if (this.isParallel()) {
      return Promise.all(array.map(fn));
    }
    return array.reduce(async function (promise) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return [...(await promise), await fn(...args)];
    }, Promise.resolve([]));
  }
}
function transactionBuilderGroup() {
  let builders = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new TransactionBuilderGroup(builders);
}
exports.TransactionBuilderGroup = TransactionBuilderGroup;
exports.transactionBuilderGroup = transactionBuilderGroup;
//# sourceMappingURL=TransactionBuilderGroup.cjs.map